import axios from 'axios';

const API_BASE = (import.meta.env.VITE_API_BASE ?? '').replace(/\/+$/, '');

export const apiClient = axios.create({
  baseURL: API_BASE || undefined,
});

export function apiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return API_BASE ? `${API_BASE}${normalizedPath}` : normalizedPath;
}

export async function apiFetch(path, init) {
  return fetch(apiUrl(path), init);
}
